<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Networked Users {{ dataSource.multiple ? '(' + dataSource.selection.selected.length + ')' : '' }}
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-lg-3 my-1" type="button" (click)="onChangeSelectedAccount()">
      <mat-icon>business</mat-icon> Select Company
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search Users"
      aria-label="Search Users" />

    <button mat-raised-button color="secondary" class="mr-2 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort matSortActive="accounts.name" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? onToggleRowSelection(row) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="accounts.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>

    <ng-container matColumnDef="users.contact_person">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Full Name
      </th>
      <td mat-cell *matCellDef="let element">
        <a (click)="onUserPublicView(element.hash, $event)"
           matTooltip="View User Public Profile">
          {{ element.contact_person }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="users.email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <ng-container matColumnDef="users.mobile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
      <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
    </ng-container>

    <ng-container matColumnDef="users.iqp_number">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>IQP Number</th>
      <td mat-cell *matCellDef="let element">{{ element.iqp_number || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="users.date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Joined</th>
      <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertMedium }}</td>
    </ng-container>

    <ng-container matColumnDef="onsite">
      <th mat-header-cell *matHeaderCellDef>Is Onsite?</th>
      <td mat-cell *matCellDef="let element">{{ element.onsite ? 'Yes' : 'No' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-raised-button
          color="primary"
          (click)="return_objects ? onSelectSingleObject(element) : onSelectSingle(element.id)"
          *ngIf="!this.dataSource.isSelected(element.id)">
          Select
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onToggleRowSelection(row)">
    </tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <mat-paginator
    #paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    mat-raised-button
    color="primary"
    class="my-2 ml-1 mr-2"
    (click)="onSelectMultiple()"
    *ngIf="data['multiple']">
    Select
  </button>

  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    (click)="onSelectAllRecords()"
    *ngIf="dataSource.isAllSelected() && (dataSource.selection.selected.length != paginator.length)">
    Select All ({{paginator.length}})
  </button>

  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    (click)="onDeselectAllRecords()"
    *ngIf="dataSource.selection.selected.length > paginator.pageSize">
    Deselect All
  </button>

  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    (click)="onDeselectSingle()"
    *ngIf="!data['multiple'] && data['selected'].length > 0">
    Deselect User
  </button>
</mat-dialog-actions>
